import {
  CloudAccountChangeV2,
  type CloudAccountChangeParams,
} from '@labrav/common'
import { useStyles } from '../ChannelOffers.styles'
import { AuthorizationSelector } from '../AuthorizationSelector'
import { ChannelOffersDropDownWithModalTrigger } from '../ChannelOfferDropdownWithModalTrigger/ChannelOffersDropdownWithModalTrigger'
import { useCallback, useMemo } from 'react'
import { useDispatch } from '../../../store'
import { useNavigate, useParams } from 'react-router-dom'
import {
  useAccountId,
  useCloudAccounts,
  extractAccountIdFromCombinedId,
  getSelectedAccountIdWithCloud,
  actionTypeWrapper,
  setSelectedAccount,
  CloudType,
  startLoading,
  stopLoading,
  LoadingTypes,
  useCurrentCloudProvider,
} from '@labrav/common'
import { setSelectedProductOnListing } from '../../../modules/productsListing/actionCreators'
import { setCloudMarketplaceProductListing } from '../../../modules/productListingFilter/action'

export const ChannelOffersFilters = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const accountId = useAccountId({ product: 'flyout' })
  const { cloud: routeCloud, accountId: routeAccountId } = useParams<{
    cloud?: string
    accountId?: string
  }>()
  const selectedCloudTypeProductListing = useCurrentCloudProvider()

  const currentAccountId = routeAccountId || accountId

  const baseMarketplaceCloudAccounts = useCloudAccounts('flyout')

  const marketplaceCloudAccounts = useMemo(
    () =>
      baseMarketplaceCloudAccounts.map(account => ({
        ...account,
        disabled: account.provider !== 'AWS',
      })),
    [baseMarketplaceCloudAccounts]
  )

  const selectedAccountIdWithCloud = getSelectedAccountIdWithCloud(
    currentAccountId,
    'flyout',
    routeCloud || selectedCloudTypeProductListing
  )

  const handleCloudAccountChange = useCallback(
    async (params: CloudAccountChangeParams) => {
      const accountId = extractAccountIdFromCombinedId(params.accountId)
      const { cloud } = params

      const cloudPath = cloud.toLowerCase()
      const pathname = `/flyout/${cloudPath}/${accountId}/offers-authorizations/channel-offers`
      navigate(pathname, { replace: true })

      await dispatch(startLoading(LoadingTypes.GENERAL))

      await dispatch(
        setSelectedAccount(accountId, 'flyout', cloud as CloudType)
      )

      await dispatch(
        actionTypeWrapper(
          selectedCloudTypeProductListing,
          setSelectedProductOnListing(undefined)
        )
      )
      await dispatch(setCloudMarketplaceProductListing(cloud))

      await dispatch(stopLoading(LoadingTypes.GENERAL))
    },
    [dispatch, navigate, selectedCloudTypeProductListing]
  )

  return (
    <div data-testid="cppo-filters" className={classes.filterWrapper}>
      <div>
        <div className={classes.authorizationSelector}>
          <AuthorizationSelector />
        </div>
      </div>
      <div style={{ width: '220px', height: '44px' }}>
        <CloudAccountChangeV2
          cloudAccounts={marketplaceCloudAccounts}
          selectedAccountId={selectedAccountIdWithCloud}
          onChange={handleCloudAccountChange}
          width={220}
          size="small"
        />
      </div>
      <ChannelOffersDropDownWithModalTrigger dropDownButtonText={'Create'} />
    </div>
  )
}
